import React from "react";
import { CheckCircle, PartyPopper } from "lucide-react";

export const BookingSuccess = ({ onReset }) => (
  <section id="book-online" className="py-20 md:py-28 bg-gradient-to-br from-[#E83E8C]/5 via-white to-[#FF9F1C]/5" data-testid="booking-success">
    <div className="max-w-2xl mx-auto px-4 text-center">
      <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
        <div className="relative inline-flex items-center justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center">
            <CheckCircle size={48} className="text-green-500" strokeWidth={1.5} />
          </div>
          <PartyPopper size={24} className="absolute -top-1 -right-3 text-[#FF9F1C] animate-bounce" />
        </div>
        <h2 className="font-['Outfit'] text-2xl md:text-3xl font-bold text-[#1E1B4B] mb-4">Booking Confirmed!</h2>
        <p className="text-[#475569] mb-2 text-sm md:text-base">Thank you for booking with DoozyGo!</p>
        <p className="text-[#475569] mb-6 text-sm md:text-base">You will receive a confirmation email, WhatsApp message & payment receipt shortly.</p>
        <button onClick={onReset} className="bg-[#E83E8C] text-white px-6 md:px-8 py-3 rounded-full font-semibold hover:bg-[#d62f7a] transition-all text-sm md:text-base" data-testid="book-another-btn">Book Another Party</button>
      </div>
    </div>
  </section>
);
